import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ============================================================================
// NETWORK FIREWALL - BLOCKS admin-control-79.emergent.host PERMANENTLY
// ============================================================================
// This MUST be imported before any network requests are made
import { initNetworkFirewall } from './utils/networkFirewall';

import devLog from './utils/devLog';

// Initialize the firewall IMMEDIATELY on app load
// This intercepts ALL fetch, XMLHttpRequest, and EventSource calls
// Any request to blocked hosts (*.emergent.host) will be DESTROYED and redirected
initNetworkFirewall();

// P5 CSRF: Global axios interceptor — attaches X-CSRF-Token to all mutating requests
import axios from 'axios';
import { getCsrfToken } from './utils/csrf';
axios.interceptors.request.use((config) => {
  const method = (config.method || '').toUpperCase();
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    const token = getCsrfToken();
    if (token) {
      config.headers['X-CSRF-Token'] = token;
    }
  }
  return config;
});

// P5 CSRF: Patch global fetch to attach X-CSRF-Token on mutating requests
const _originalFetch = window.fetch;
window.fetch = function(input, init = {}) {
  const method = (init.method || 'GET').toUpperCase();
  if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    const token = getCsrfToken();
    if (token) {
      init.headers = init.headers || {};
      if (init.headers instanceof Headers) {
        init.headers.set('X-CSRF-Token', token);
      } else {
        init.headers['X-CSRF-Token'] = token;
      }
    }
  }
  return _originalFetch.call(window, input, init);
};

devLog.log('🛡️ [ELON PROMPT AI] Network firewall active - unauthorized hosts BLOCKED');
// ============================================================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
